import { Emergency, Label } from "@mui/icons-material";
import { SxProps, Theme } from "@mui/material";

export const Links = {
  root: "/",
  dashboard: "/dashboard",
  appointmentHome: "/appointmenthome",
  allAppointments: "/allappointments",
  rescheduleAppointment: "/rescheduleappointment",
  patientDetails: "/patientdetails",
  updatePatient: "/updatepatient",
  newPatient: "/newpatient",
  basicInformation: "/patient/basicinformation",
  prescriptions: "/patient/prescriptions",
  medicalRecords: "/patient/medicalrecords",
  newPrescription: "/newprescription",
  facilityBasicDetails: "/facilitybasicdetails",
  facilityService: "/facilityservices",
  facilityStaff: "/facilitystaff",
  patientAnalytics: "/patientanalytics",
  schedulingAnalytics: "/schedulinganalytics",
  profileSettings: "/profilesettings",
  availabilitySettings: "/availabilitysettings",
  prescriptionSettings: "/prescriptionsettings",
  billing: "/billing",
  billingHome: "/billing/home", // New Route
  billingList: "/billing/list", // New Route
  patient: "/patient",
  myWorklist: "/myworklist",
  mySettings: "/mysettings",
  enquiry: "/enquiry",
  plans: "/plans",
  reports: "/reports",
  others: "/*",
};

export const LocalStorageKeys = {
  MyWorkListTabs : "myworklist-tabs",
  MyWorkListTabHistory : "myworklist-tabHistory",
  MyWorkListActiveTab : "myworklist-active-tab",
  VisitsTabs : "visits-tabs",
  VisitsActiveTab : "visits-active-tab",
  VisitsTabHistory : "visits-tabHistory",
};

export const MainMenu = {
  dashboard: "Dashboard",
  myWorklist: "MyWorklist",
  appointments: "Appointments",
  patients: "Patients",
  billing: "Billing",
  mySettings: "MySettings",
  facilitySettings: "FacilitySettings",
  visits: "Visits",
  enquiry: "Enquiry",
  plans: "Plans",
  reports: "Reports",
};

export const ChartColors = {
  color1: "#38a2ebbf",
  color2: "#f66384bf",
  color3: "#4bc0c0bf",
  color4: "#f89f40bf",
  color5: "#9966ffbf",
  color6: "#c9cbcfbf",
};

export const URLs = {
  AppointmentAPI: "/api/appointment",
  UserAccountAPI: "/api/account",
  FacilityAPI: "/api/facility",
  FacilitySettingsAPI: "/api/facilitysettings",
  ClinicalServiceAPI: "/api/facilitysettings/clinicalservice",
  PatientAPI: "/api/patient",
  PrescriptionAPI: "/api/prescription",
  BillingAPI: "/api/billing",
};

export const PrescriptionTypes = {
  GeneralPrescription: "GeneralPrescription",
  PhysiotherapyPrescription: "PhysiotherapyPrescription",
  DentalPrescription: "DentalPrescription",
  PathologyLabReport: "PathologyLabReport",
  FrozenShoulder: "FrozenShoulders",
};

export const NoteTypes = [
  { value: "General", label: "General Notes" },
  { value: "PhysiotherapyTreatment", label: "Physiotherapy Notes" },
  { value: "Note", label: "Notes" },
];

export const MedicalRecordTypes = [
  { value: "MedicalRecord", label: "Medical Record" },
  { value: "Whiteboard", label: "Drawing" },  // ✅ Whiteboard → Drawing
];

export const AvailablePrescriptionTypes = [
  {
    value: PrescriptionTypes.GeneralPrescription,
    label: "General Prescription",
    category: "prescription",
  },
  {
    value: PrescriptionTypes.PhysiotherapyPrescription,
    label: "Physiotherapy Prescription",
    category: "prescription",
  },
  {
    value: PrescriptionTypes.DentalPrescription,
    label: "Dental Prescription",
    category: "prescription",
  },
  {
    value: PrescriptionTypes.PathologyLabReport,
    label: "Pathology Lab Report",
    category: "prescription",
  },

  {
    value: PrescriptionTypes.GeneralPrescription,
    label: "General Prescription",
    category: "prescription",
  },
  {
    value: PrescriptionTypes.PhysiotherapyPrescription,
    label: "Physiotherapy Prescription",
    category: "prescription",
  },
  // {
  //   value: PrescriptionTypes.DentalPrescription,
  //   label: "Dental Prescription",
  //   category: "prescription",
  // },
 
  {
    value: PrescriptionTypes.PathologyLabReport,
    label: "Pathology Lab Report",
    category: "prescription",
  },
  {
    value: PrescriptionTypes.FrozenShoulder,
    label: "Frozen Shoulder",
    category: "prescription",
  },

  { value: NoteTypes[0].value, label: NoteTypes[0].label, category: "note" },
  { value: NoteTypes[1].value, label: NoteTypes[1].label, category: "note" },
  { value: NoteTypes[2].value, label: NoteTypes[2].label, category: "note" },
  
 {
    value: MedicalRecordTypes[0].value,
    label: MedicalRecordTypes[0].label,
    category: "record",
  },
  {
    value: MedicalRecordTypes[1].value,  // ✅ ab "Whiteboard" milega
    label: MedicalRecordTypes[1].label,
    category: "record",
  }
];

export const ServiceLocations = {
  Clinic: "Clinic",
  Online: "Online",
  Home: "Home",
};
export const DentalInvestigationParameters = [
  { value: "XRay", displayValue: "X-Ray", selected: false, subType: [], notes: "" },
  { value: "RVG", displayValue: "RVG (Radiovisiography)", selected: false, notes: "" },
  { value: "CBCT", displayValue: "CBCT (Cone Beam CT)", selected: false, notes: "" },
  { value: "OPG", displayValue: "OPG (Orthopantomogram)", selected: false, subType: { lateralCeph: { displayValue: "Lateral Cephalogram", selected: false } }, notes: "" },
];
export const Prefixes = ["Mr.", "Mrs.", "Ms.", "Dr.", "Baby", "Others"];

export const Genders = ["Male", "Female", "Others", "Unknown"];

export const BloodGroupOptions = [
  { value: "APositive", displayValue: "A+" },
  { value: "ANegative", displayValue: "A-" },
  { value: "BPositive", displayValue: "B+" },
  { value: "BNegative", displayValue: "B-" },
  { value: "OPositive", displayValue: "O+" },
  { value: "ONegative", displayValue: "O-" },
  { value: "ABPositive", displayValue: "AB+" },
  { value: "ABNegative", displayValue: "AB-" },
  { value: "Unknown", displayValue: "Unknown" },
];

export const ConfigurableItems = [
  {
    value: "GeneralPrescription",
    label: "General Prescription",
    category: "prescription",
  },
  {
    value: "PhysiotherapyPrescription",
    label: "Physiotherapy Prescription",
    category: "prescription",
  },
  {
    value: "PathologyLabReport",
    label: "Pathology Lab Report",
    category: "prescription",
  },
  { value: "Note", label: "Notes", category: "note" },
  { value: "GeneralNote", label: "General Note", category: "note" },
  { value: "PhysiotherapyNote", label: "Physiotherapy Note", category: "note" },
  { value: "MedicalRecord", label: "Medical Record", category: "record" },
  { value: "Whiteboard", label: "Drawing", category: "record" }, 
];

// export const SelectableMedicalHistoryConditions = [
//   { value: "Diabetes", selected: false, displayValue: "Diabetes" },
//   { value: "Hypertension", selected: false, displayValue: "Hypertension" },
//   { value: "Asthma", selected: false, displayValue: "Asthma" },
//   { value: "HeartDisease", selected: false, displayValue: "Heart Disease" },
//   { value: "Thyroid", selected: false, displayValue: "Thyroid" },
//   { value: "Epilepsy", selected: false, displayValue: "Epilepsy" },
// ];
export const SelectableComorbidities = [
  { value: "Anemia", selected: false, displayValue: "Anemia" },
  { value: "Obesity", selected: false, displayValue: "Obesity" },
  { value: "Cancer", selected: false, displayValue: "Cancer" },
  { value: "COPD", selected: false, displayValue: "COPD" },
  {
    value: "ChronicKidneyDisease",
    selected: false,
    displayValue: "Chronic Kidney Disease",
  },
  { value: "LiverDisease", selected: false, displayValue: "Liver Disease" },
  { value: "Stroke", selected: false, displayValue: "Stroke" },
  {
    value: "AutoimmuneDisorder",
    selected: false,
    displayValue: "Autoimmune Disorder",
  },
  { value: "Diabetes", selected: false, displayValue: "Diabetes" },
  { value: "Hypertension", selected: false, displayValue: "Hypertension" },
  { value: "Asthma", selected: false, displayValue: "Asthma" },
  { value: "HeartDisease", selected: false, displayValue: "Heart Disease" },
  { value: "Thyroid", selected: false, displayValue: "Thyroid" },
  { value: "Epilepsy", selected: false, displayValue: "Epilepsy" },
  {
    value: "Other",
    selected: false,
    displayValue: "Other",
    additionalText: "",
  },
];
export const SelectablePainType = [
  { value: "Constant", selected: false, displayValue: "Constant" },
  { value: "Intermittent", selected: false, displayValue: "Intermittent" },
  { value: "Radiating", selected: false, displayValue: "Radiating" },
  { value: "Throbbing", selected: false, displayValue: "Throbbing" },
  { value: "PinsNeedles", selected: false, displayValue: "Pins and Needles" },
  { value: "Burning", selected: false, displayValue: "Burning" },
];
export const PhysioTreatmentMethods = [
  { value: "IFT", selected: false, displayValue: "IFT" },
  { value: "MFR", selected: false, displayValue: "MFR" },
  { value: "UltraSound", selected: false, displayValue: "UltraSound" },
  { value: "Tens", selected: false, displayValue: "TENS" },
  {
    value: "StrengtheningExercise",
    selected: false,
    displayValue: "Strengthening Exercise",
  },
  {
    value: "FlexibilityExercise",
    selected: false,
    displayValue: "Flexibility Exercise",
  },
  { value: "CoreStability", selected: false, displayValue: "Core Stability" },
  {
    value: "Others",
    selected: false,
    displayValue: "Others",
    additionalText: "",
  },
];

export const NationalIdTypes = [
  "Aadhaar",
  "Passport",
  "PAN Card",
  "Driving License",
  "Govt. Employee Id",
];

export const AppointmentStatus = {
  Scheduled: "Scheduled",
  CheckedIn: "CheckedIn",
  NoShow: "NoShow",
  Cancelled: "Cancelled",
  InProgress: "InProgress",
  Completed: "Completed",
};

export const PlanStatus = {
  Planned: "Planned",
  InProgress: "InProgress",
  Completed: "Completed",
  PartiallyCompleted: "PartiallyCompleted",
};

export const ServiceStatus = {
  NotStarted: "NotStarted",
  InProgress: "InProgress",
  Completed: "Completed",
};

export const BillingStatus = {
  NotStarted: "NotBilled",
  InProgress: "AddedToBill",
  Completed: "BillFinalized",
};

export const VisitTypes = {
  OPD: "OPD",
  Home: "Home",
  Online: "Online",
  IPD: "IPD",
  Emergency: "Emergency",
};

export const DateRangeOptions = {
  Today: "Today",
  Yesterday: "Yesterday",
  Next7Days: "Next7Days",
  Last7Days: "Last7Days",
  Last30Days: "Last30Days",
  Next30Days: "Next30Days",
  Custom: "Custom",
};

export const PaymentModes = [
  { value: "Cash", displayValue: "Cash" },
  { value: "CreditCard", displayValue: "Credit Card" },
  { value: "DebitCard", displayValue: "Debit Card" },
  { value: "NetBanking", displayValue: "Net Banking" },
  { value: "UPI", displayValue: "UPI" },
  { value: "AccountTransfer", displayValue: "Account Transfer" },
  { value: "CreditNote", displayValue: "Credit Note" },
];

export const RefundPaymentModes = [
  { value: "Cash", displayValue: "Cash" },
  { value: "UPI", displayValue: "UPI" },
  { value: "CreditNote", displayValue: "Credit Note" },
  { value: "AccountTransfer", displayValue: "Account Transfer" },
  { value: "Cheque", displayValue: "Cheque" },
];

export const painLevelValue = [
  { value: 0, label: 0 },
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 },
];

export const TestNames = [
  "ANA",
  "Blood Culture",
  "Blood Grouping & Rh Typing",
  "Blood Sugar (Fasting)",
  "Blood Sugar (PP)",
  "Bone Density (DEXA)",
  "Chest X-Ray",
  "Complete Blood Count (CBC)",
  "COVID-19 RT-PCR",
  "CRP",
  "CT Scan",
  "D-Dimer",
  "ECG",
  "Electrolytes",
  "ESR",
  "Hepatitis B Surface Antigen (HBsAg)",
  "HIV Test",
  "Lipid Profile",
  "Liver Function Test (LFT)",
  "Mammography",
  "MRI",
  "Pap Smear",
  "Procalcitonin",
  "PT/INR",
  "RA Factor",
  "Renal Function Test (RFT)",
  "Serum Albumin",
  "Serum Bilirubin",
  "Serum Calcium",
  "Serum Creatinine",
  "Serum Potassium",
  "Serum Sodium",
  "Stool Culture",
  "Stool Routine",
  "Thyroid Profile (T3, T4, TSH)",
  "Ultrasound Abdomen",
  "Urine Culture",
  "Urine Pregnancy Test",
  "Urine Routine",
  "Vitamin B12",
  "Vitamin D",
];

export const MedicineDurationOptions = [
  "1 day",
  "2 days",
  "3 days",
  "5 days",
  "7 days",
  "10 days",
  "14 days",
  "21 days",
  "1 month",
  "2 months",
  "3 months",
  "Until finished",
  "As directed",
  "Single dose",
];

export const iconButtonStyles = {
  circularSecondary: {
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    padding: "4px",
    border: "1px solid",
    borderColor: "secondary.main",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  // Add other common button styles here as needed
  circularPrimary: {
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    padding: "4px",
    border: "1px solid",
    borderColor: "primary.main",
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.04)",
    },
  },
};
export const paymentModes = [
  "Cash",
  "CreditCard",
  "DebitCard",
  "NetBanking",
  "UPI",
  "AccountTransfer",
  "CreditNote",
  "Cheque",
];

export const refundPaymentModes = [
  "Cash",
  "UPI",
  "CreditNote",
  "AccountTransfer",
  "Cheque",
];

export const recordTypeOptions = [
  "Laboratory Result",
  "Discharge Summary",
  "Consent Form",
  "Prescription",
  "Radiology Reports",
  "Administrative Data",
  "Medical History",
  "Operative Report",
  "Pathology Report",
  "Others",
];

export const UserRolesConstants = {
  FacilityAdmin: "FacilityAdmin",
  Physician: "Physician",
  FrontDesk: "FrontDesk",
  Nurse: "Nurse",
  Accountant: "Accountant",
  LabTechnician: "LabTechnician",
  Pharmacist: "Pharmacist",
  InventoryManager: "InventoryManager",
};

export const UserRoles = [
  "FacilityAdmin",
  "Physician",
  "FrontDesk",
  "Nurse",
  "Accountant",
  "LabTechnician",
  "Pharmacist",
  "InventoryManager",
];

// Duration options for dropdown
export const DurationOptions = [
  { value: "15", label: "15 Minutes" },
  { value: "30", label: "30 Minutes" },
  { value: "45", label: "45 Minutes" },
  { value: "60", label: "1 Hour" },
  { value: "90", label: "1.5 Hours" },
  { value: "120", label: "2 Hours" },
];

// Frequency options for dropdown
export const FrequencyOptions = [
  { value: "daily", label: "Daily" },
  { value: "alternate", label: "Alternate Day" },
  { value: "weekly", label: "Every Week" },
  { value: "biweekly", label: "Every 2 Weeks" },
  { value: "monthly", label: "Monthly" },
];
// Sample categories with their main types
export const samples = [
  { id: 1, name: "Blood Samples", category: "blood" },
  { id: 2, name: "Urine Samples", category: "urine" },
  { id: 3, name: "Stool (Fecal) Samples", category: "stool" },
  { id: 4, name: "Swabs & Body Fluids", category: "swabs" },
  {
    id: 5,
    name: "Body Fluids (Cytology / Biochemistry)",
    category: "body_fluids",
  },
  { id: 6, name: "Tissue & Cell Samples", category: "tissue" },
  { id: 7, name: "Hair, Nail, Skin", category: "hair_nail_skin" },
];

// All sample types organized by category
export const sampleTypes = [
  // Blood Sample Types
  { value: "whole_blood", displayValue: "Whole Blood", category: "blood" },
  { value: "serum", displayValue: "Serum", category: "blood" },
  { value: "plasma", displayValue: "Plasma", category: "blood" },

  // Urine Sample Types
  {
    value: "random_urine",
    displayValue: "Random Urine Sample",
    category: "urine",
  },
  {
    value: "first_morning_urine",
    displayValue: "First Morning Urine",
    category: "urine",
  },
  {
    value: "24hour_urine",
    displayValue: "24-Hour Urine Collection",
    category: "urine",
  },
  {
    value: "midstream_urine",
    displayValue: "Midstream Clean-Catch Urine",
    category: "urine",
  },
  {
    value: "catheterized_urine",
    displayValue: "Catheterized Urine",
    category: "urine",
  },
  {
    value: "suprapubic_urine",
    displayValue: "Suprapubic Aspiration",
    category: "urine",
  },

  // Stool Sample Types
  {
    value: "random_stool",
    displayValue: "Single Random Sample",
    category: "stool",
  },
  {
    value: "multiple_stool",
    displayValue: "Multiple Samples",
    category: "stool",
  },

  // Swab Types
  { value: "throat_swab", displayValue: "Throat Swab", category: "swabs" },
  {
    value: "nasal_swab",
    displayValue: "Nasal/Nasopharyngeal Swab",
    category: "swabs",
  },
  {
    value: "vaginal_swab",
    displayValue: "Vaginal/Cervical Swab (Pap Smear)",
    category: "swabs",
  },
  { value: "urethral_swab", displayValue: "Urethral Swab", category: "swabs" },
  { value: "wound_swab", displayValue: "Wound Swab", category: "swabs" },

  // Body Fluid Types
  {
    value: "csf",
    displayValue: "Cerebrospinal Fluid (CSF)",
    category: "body_fluids",
  },
  {
    value: "pleural_fluid",
    displayValue: "Pleural Fluid",
    category: "body_fluids",
  },
  {
    value: "peritoneal_fluid",
    displayValue: "Peritoneal Fluid (Ascitic)",
    category: "body_fluids",
  },
  {
    value: "pericardial_fluid",
    displayValue: "Pericardial Fluid",
    category: "body_fluids",
  },
  {
    value: "synovial_fluid",
    displayValue: "Synovial Fluid (Joint)",
    category: "body_fluids",
  },
  {
    value: "amniotic_fluid",
    displayValue: "Amniotic Fluid",
    category: "body_fluids",
  },

  // Tissue & Cell Types
  {
    value: "fnac",
    displayValue: "Fine Needle Aspiration Cytology (FNAC)",
    category: "tissue",
  },
  {
    value: "core_needle_biopsy",
    displayValue: "Core Needle Biopsy",
    category: "tissue",
  },
  {
    value: "incisional_biopsy",
    displayValue: "Incisional Biopsy",
    category: "tissue",
  },
  {
    value: "excisional_biopsy",
    displayValue: "Excisional Biopsy",
    category: "tissue",
  },
  { value: "pap_smear", displayValue: "Pap Smear", category: "tissue" },
  { value: "skin_scraping", displayValue: "Skin Scraping", category: "tissue" },
  {
    value: "bronchial_brush",
    displayValue: "Bronchial Brush",
    category: "tissue",
  },

  // Hair, Nail, Skin Types
  {
    value: "hair_sample",
    displayValue: "Hair Sample",
    category: "hair_nail_skin",
  },
  {
    value: "nail_clippings",
    displayValue: "Nail Clippings/Scrapings",
    category: "hair_nail_skin",
  },
  {
    value: "skin_biopsy",
    displayValue: "Skin Biopsy",
    category: "hair_nail_skin",
  },
];

// All collection methods organized by category
export const sampleCollectionMethods = [
  // Blood Collection Methods
  {
    value: "venipuncture",
    displayValue: "Venipuncture",
    category: "blood",
    description: "From vein, usually in arm",
  },
  {
    value: "capillary_puncture",
    displayValue: "Capillary Puncture",
    category: "blood",
    description: "Finger prick, heel prick in newborns",
  },
  {
    value: "arterial_puncture",
    displayValue: "Arterial Puncture",
    category: "blood",
    description: "For arterial blood gases (ABG)",
  },

  // Urine Collection Methods
  {
    value: "voiding_sterile",
    displayValue: "Voiding into Sterile Container",
    category: "urine",
  },
  {
    value: "catheter_insertion",
    displayValue: "Catheter Insertion",
    category: "urine",
  },
  {
    value: "needle_aspiration_urine",
    displayValue: "Needle Aspiration",
    category: "urine",
    description: "Rare, mostly pediatrics",
  },

  // Stool Collection Methods
  {
    value: "patient_collection_stool",
    displayValue: "Patient Collection in Sterile Container",
    category: "stool",
  },

  // Swab Collection Methods
  {
    value: "sterile_cotton_swab",
    displayValue: "Sterile Cotton Swab",
    category: "swabs",
  },
  { value: "flocked_swab", displayValue: "Flocked Swab", category: "swabs" },

  // Body Fluid Collection Methods
  {
    value: "lumbar_puncture",
    displayValue: "Lumbar Puncture",
    category: "body_fluids",
    description: "For CSF",
  },
  {
    value: "thoracentesis",
    displayValue: "Thoracentesis",
    category: "body_fluids",
    description: "For pleural fluid",
  },
  {
    value: "paracentesis",
    displayValue: "Paracentesis",
    category: "body_fluids",
    description: "For peritoneal fluid",
  },
  {
    value: "pericardiocentesis",
    displayValue: "Pericardiocentesis",
    category: "body_fluids",
    description: "For pericardial fluid",
  },
  {
    value: "arthrocentesis",
    displayValue: "Arthrocentesis",
    category: "body_fluids",
    description: "For synovial fluid",
  },
  {
    value: "amniocentesis",
    displayValue: "Amniocentesis",
    category: "body_fluids",
    description: "For amniotic fluid",
  },

  // Tissue Collection Methods
  { value: "needle_biopsy", displayValue: "Needle Biopsy", category: "tissue" },
  {
    value: "incisional_biopsy_method",
    displayValue: "Incisional Biopsy",
    category: "tissue",
    description: "Part of tissue removed",
  },
  {
    value: "excisional_biopsy_method",
    displayValue: "Excisional Biopsy",
    category: "tissue",
    description: "Entire lesion removed",
  },
  {
    value: "scraping_brushing",
    displayValue: "Scraping/Brushing",
    category: "tissue",
  },

  // Hair, Nail, Skin Collection Methods
  { value: "cutting", displayValue: "Cutting", category: "hair_nail_skin" },
  { value: "scraping", displayValue: "Scraping", category: "hair_nail_skin" },
  {
    value: "punch_biopsy",
    displayValue: "Punch Biopsy",
    category: "hair_nail_skin",
  },
];

// Updated collection method options (maintaining your existing structure)
export const sampleCollectionMethodOptions = [
  { value: "blood_collection", displayValue: "Blood Collection Methods" },
  { value: "urine_collection", displayValue: "Urine Collection Methods" },
  { value: "stool_collection", displayValue: "Stool Collection Methods" },
  { value: "swab_collection", displayValue: "Swab Collection Methods" },
  { value: "biopsy_collection", displayValue: "Biopsy Collection Methods" },
  {
    value: "body_fluid_collection",
    displayValue: "Body Fluid Collection Methods",
  },
  { value: "tissue_collection", displayValue: "Tissue Collection Methods" },
  {
    value: "hair_nail_skin_collection",
    displayValue: "Hair, Nail & Skin Collection Methods",
  },
];

export const RouteAccess = {
  MyWorklist: [ "Physician", "LabTechnician"],
  Plans: ["FrontDesk", ],
  Visits: ["FrontDesk",],
  Billing: ["FacilityAdmin", "Accountant", "FrontDesk"],
  Enquiry: ["FacilityAdmin", "FrontDesk"],
  Report: ["FacilityAdmin"],
};

// ROM movements list
export const romMovements = [
  { name: "Flexion", normal: 180 },
  { name: "Extension", normal: 60 },
  { name: "Abduction", normal: 180 },
  { name: "Adduction", normal: 50 },
  { name: "Medial Rotation", normal: 90 },
  { name: "Lateral Rotation", normal: 90 },
];

// Options constants
export const muscleOptions = [
  "Supraspinatus",
  "Infraspinatus",
  "Subscapularis",
  "Teres Minor",
  "Deltoid",
  "Pectoral",
];

export const difficultyOptions = [
  "Clothing",
  "Combing",
  "Lifting Objects",
  "Overhead Activities",
  "Grip & Pinch",
];

export const modalityOptions = [
  "Moist Heat",
  "SWD",
  "Shock Wave",
  "Combination Therapy",
  "LASER",
  "TENS",
  "IFT",
  "US",
];

export const exerciseOptions = [
  "Graded Mobilization",
  "Capsular Stretching",
  "Strengthening Rotator Cuff",
 
];
export const WorkItemViewModes = {
  DEFAULT: "default",
  FROM_VISIT: "fromVisit",
  
  // FROM_PATIENT: "fromPatient",
  // READ_ONLY: "readOnly",
};
